export default {
  today: 'Hoy',
  tomorrow: 'Mañana',
};
